import { Component, app, ojs } from "modular-openscriptjs";
import { pageInfo, tab, empty } from "../../helpers";
import { PAGES, api } from "../../declarations";
import { routes } from "../../backendRoutes";
import { dom } from "../../fotastart";
import CapaTransfersView from "../Views/CapaTransfersView";

const h = app("h");

ojs(CapaTransfersView);

export default class TransfersPage extends Component {
	render(...args) {
		pageInfo(PAGES.TRANSFERS);

		this.getCapaTransfers();

		return h.div(
			{ class: "py-md-5" },
			h.Tabs({
				holders: {
					nav: h.div({
						class: "nav nav-underline fs-5 nav-fill mb-3",
					}),
					body: h.div({ class: "tab-content" }),
				},
				tabs: [
					tab(
						h.button(
							{ class: "nav-link active" },

							h.span(
								"Transferred ",
								h.i({ class: "fas fa-arrow-up" }),
							),
						),
						h.div(
							{ class: "tab-pane fade show active" },
							h.div(
								{ hook: "tc-transferred-holder" },
								h.Spinner(),
							),
						),
					),
					tab(
						h.button(
							{ class: "nav-link" },

							h.span(
								"Received ",
								h.i({ class: "fas fa-arrow-down" }),
							),
						),
						h.div(
							{ class: "tab-pane fade" },
							h.div({ hook: "tc-received-holder" }, h.Spinner()),
						),
					),
				],
			}),

			...args,
		);
	}

	async getCapaTransfers() {
		let res = await api.get(routes.transfers, {}, { silent: true });

		if (res) {
			let transfers = res.data.transfers;
			let receipts = res.data.receipts;

			this.populateTabs(
				"transferred",
				"tc-transferred-holder",
				transfers,
			);
			this.populateTabs("received", "tc-received-holder", receipts);
		} else {
			this.populateTabs("Transferred", "tc-transferred-holder", []);
			this.populateTabs("Received", "tc-received-holder", []);
		}
	}

	populateTabs(type, name, data) {
		let holder = dom.get(`[hook="${name}"]`);
		dom.get("ojs-spinner", holder)?.remove();

		if (empty(data)) {
			h.p(
				{
					parent: holder,
					class: "fst-italic fw-500 text-center text-secondary",
				},
				`You haven't ${type} any Capa yet...`,
			);
			return;
		}

		for (let transaction of data) {
			h.CapaTransfersView(transaction, type, { parent: holder });
		}
	}
}
